import React from 'react';
import { Link } from 'react-router-dom';

interface LightNavigationProps {
  title?: string;
  showBackButton?: boolean;
  onBack?: () => void;
}

const LightNavigation: React.FC<LightNavigationProps> = ({
  title = "Pre-Closing Checklist",
  showBackButton = true,
  onBack
}) => {
  return (
    <nav className="bg-white border-b border-gray-100 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-28">
          {/* Left side - Logo and back button */}
          <div className="flex items-center space-x-4">
            {showBackButton && (
              <button
                onClick={onBack}
                className="p-2 text-gray-400 hover:text-gray-600 transition-colors rounded-lg hover:bg-gray-50"
                title="Go back"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </button>
            )}
            
            <Link to="/" className="flex items-center">
              <img 
                src="/24lp-logo-primary.png"
                alt="Twenty Four Capital" 
                className="h-20 md:h-24 w-auto object-contain"
              />
            </Link>
          </div>

          {/* Center - Title */}
          <div className="flex-1 flex justify-center">
            <h1 className="text-lg font-semibold text-gray-900 truncate">
              {title}
            </h1>
          </div>

          {/* Right side - Actions */}
          <div className="flex items-center space-x-3">
            <Link
              to="/dashboard"
              className="text-sm text-gray-600 hover:text-gray-900 transition-colors px-3 py-2 rounded-md hover:bg-gray-50"
            >
              Dashboard
            </Link>
            <Link
              to="/support"
              className="text-sm text-gray-600 hover:text-gray-900 transition-colors px-3 py-2 rounded-md hover:bg-gray-50"
            >
              Support
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default LightNavigation; 